/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Pretty_Orangutan_SavorInputs */

const en_raw_pretty_orangutan_savor = /** @type {(inputs: Raw_Pretty_Orangutan_SavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No benchmarks found.`)
};

const de_raw_pretty_orangutan_savor = /** @type {(inputs: Raw_Pretty_Orangutan_SavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Benchmarks gefunden.`)
};

/**
* | output |
* | --- |
* | "No benchmarks found." |
*
* @param {Raw_Pretty_Orangutan_SavorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const raw_pretty_orangutan_savor = /** @type {((inputs?: Raw_Pretty_Orangutan_SavorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Pretty_Orangutan_SavorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_raw_pretty_orangutan_savor(inputs)
	return de_raw_pretty_orangutan_savor(inputs)
});